import { useState, useEffect } from "react";
import "./AdminDashboard.css";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import PageWrapper from "../../common/PageWrapper";
import PropTypes from "prop-types";
import { Link, useNavigate, useLocation } from "react-router-dom";
import CreateUserAdminForm from "../../../pages/auth/ConnexionForm/CreateUserAdminForm";
import CreateConcessionForm from "./CreateConcessionForm";
import CreateGroupForm from "./CreateGroupForm";
import DocumentModal from "../../Forms/PdfForm/DocumentModal";
import EditUserModal from "./EditUserModal";
import UserProfileModal from "./UserProfileModal";
import ConcessionProfileModal from "./ConcessionProfileModal";
import axios from "axios";
import VendreEnLot from '../Modale/VendreEnLot';

const AdminDashboard = ({ menuState }) => {
  const { isMenuOpen, setIsMenuOpen, onMenuToggle } = menuState || {};
  const [activeTab, setActiveTab] = useState("users");
  const [isCreateUserFormOpen, setIsCreateUserFormOpen] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [selectedVehicleId, setSelectedVehicleId] = useState(null);
  const [isCreateConcessionFormOpen, setIsCreateConcessionFormOpen] = useState(false);
  const [isCreateGroupFormOpen, setIsCreateGroupFormOpen] = useState(false);
  const [profileFilters, setProfileFilters] = useState({
    siret: "",
    concession: "",
    ville: "",
    nom: "",
    prenom: "",
    identifier: "",
  });

  const [vehicleFilters, setVehicleFilters] = useState({
    statut: "",
    numero_dossier: "",
    numero_chassis: "",
    vendeur: "",
    nom_client: "",
  });

  const [users, setUsers] = useState([]);
  // const [currentUser, setCurrentUser] = useState(null);
  const [vehicules, setVehicles] = useState([]);
  const [concessions, setConcessions] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [selectedVehicles, setSelectedVehicles] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedConcession, setSelectedConcession] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showUserProfile, setShowUserProfile] = useState(false);
  const [showConcessionProfile, setShowConcessionProfile] = useState(false);
  const [editingConcession, setEditingConcession] = useState(false);
  const [showVendreEnLotModal, setShowVendreEnLotModal] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002/api";

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const loadData = async () => {
      try {
        setIsLoading(true);
        await Promise.all([fetchUsers(), fetchVehicles(), fetchConcessions()]);
      } catch (error) {
        console.error("Erreur chargement données:", error);
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadData();
  }, [location]);

  useEffect(() => {
    const filteredResults = filterUsers();
    setFilteredUsers(filteredResults);
  }, [profileFilters, users]);

  const fetchConcessions = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/concessions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Erreur lors de la récupération des concessions");
      }

      const concessionsData = await response.json();

      const concessionsArray = Array.isArray(concessionsData)
        ? concessionsData
        : (Array.isArray(concessionsData.data) ? concessionsData.data : []);

      setConcessions(concessionsArray);
    } catch (error) {
      console.error("Erreur:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenConcessionProfile = (concession) => {
    setSelectedConcession(concession);
    setShowConcessionProfile(true);
  };

  const handleCloseConcessionProfile = () => {
    setShowConcessionProfile(false);
  };

  const handleEditConcession = (concession) => {
    setSelectedConcession(concession);
    setEditingConcession(true);
    setIsCreateConcessionFormOpen(true);
  };

  const findConcessionByName = (concessionName) => {
    return concessions.find(c => c.nom === concessionName);
  };

  const fetchVehicles = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");

      try {
        const vehiclesResponse = await fetch(`${API_URL}/vehicules`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
        });

        if (vehiclesResponse.ok) {
          const vehiclesData = await vehiclesResponse.json();
          // console.log("Données des véhicules reçues:", vehiclesData);

          if (!vehiclesData || (!Array.isArray(vehiclesData) && !Array.isArray(vehiclesData.data))) {
            console.error("Format de données de véhicules incorrect:", vehiclesData);
            setVehicles([]);
            setFilteredVehicles([]);
            return;
          }

          const vehiclesArray = Array.isArray(vehiclesData)
            ? vehiclesData
            : (Array.isArray(vehiclesData.data) ? vehiclesData.data : []);

          setVehicles(vehiclesArray);
          setFilteredVehicles(vehiclesArray);
          return;
        }
      } catch (error) {
        // console.log("Tentative avec URL de production échouée, essai en local...");
      }

      const localResponse = await fetch(`${API_URL}/vehicules`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
      });

      if (!localResponse.ok) {
        throw new Error("Erreur lors de la récupération des véhicules test");
      }

      const vehiclesData = await localResponse.json();

      if (!vehiclesData || (!Array.isArray(vehiclesData) && !Array.isArray(vehiclesData.data))) {
        console.error("Format de données de véhicules incorrect (local):", vehiclesData);
        setVehicles([]);
        setFilteredVehicles([]);
        return;
      }

      const vehiclesArray = Array.isArray(vehiclesData)
        ? vehiclesData
        : (Array.isArray(vehiclesData.data) ? vehiclesData.data : []);

      setVehicles(vehiclesArray);
      setFilteredVehicles(vehiclesArray);
    } catch (error) {
      console.error("Erreur de récupération des véhicules:", error);
      setError(error.message);
      setVehicles([]);
      setFilteredVehicles([]);
    } finally {
      setIsLoading(false);
    }
  };

  const filterVehicles = () => {
    if (!vehicules || !Array.isArray(vehicules) || vehicules.length === 0) {
      return [];
    }

    console.log(`Filtrage de ${vehicules.length} véhicules`);

    const {
      statut,
      numero_dossier,
      numero_chassis,
      vendeur,
      nom_client,
    } = vehicleFilters;

    if (
      !statut &&
      !numero_dossier.trim() &&
      !numero_chassis.trim() &&
      !vendeur.trim() &&
      !nom_client.trim()
    ) {
      return vehicules;
    }

    return vehicules.filter((vehicle) => {
      if (!vehicle) return false;

      return (
        (statut === "" || (vehicle.statut || "") === statut) &&
        (numero_dossier.trim() === "" ||
          (vehicle.numero_dossier || "")
            .toLowerCase()
            .includes(numero_dossier.trim().toLowerCase())) &&
        (numero_chassis.trim() === "" ||
          (vehicle.veh_6 || "")
            .toLowerCase()
            .includes(numero_chassis.trim().toLowerCase())) &&
        (vendeur.trim() === "" ||
          (vehicle.vendeur_nom || "")
            .toLowerCase()
            .includes(vendeur.trim().toLowerCase())) &&
        (nom_client.trim() === "" ||
          (vehicle.nom_client || "")
            .toLowerCase()
            .includes(nom_client.trim().toLowerCase()))
      );
    });
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setProfileFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedVehicles(filteredVehicles.map((vehicle) => vehicle.id));
    } else {
      setSelectedVehicles([]);
    }
    setSelectAll(e.target.checked);
  };

  const handleSelectVehicle = (vehicleId) => {
    setSelectedVehicles((prev) => {
      if (prev.includes(vehicleId)) {
        return prev.filter((id) => id !== vehicleId);
      } else {
        return [...prev, vehicleId];
      }
    });
  };

  const handleVehicleFilterChange = (e) => {
    const { name, value } = e.target;
    setVehicleFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleOpenDocumentModal = (vehicleId) => {
    setSelectedVehicleId(vehicleId);
    setIsDocumentModalOpen(true);
  };

  const handleDuplicateVehicle = async (vehicleId) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${API_URL}/vehicules/${vehicleId}/duplicate`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.ok) {
        const newVehicle = await response.json();
        setVehicles([...vehicules, newVehicle]);
        setFilteredVehicles([...filteredVehicles, newVehicle]);
        alert("Véhicule dupliqué avec succès");
      } else {
        throw new Error("Erreur lors de la duplication du véhicule");
      }
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la duplication : " + error.message);
    }
  };

  const handleUpdateVehicleStatus = async (vehicleId, newStatus) => {
    try {
      const response = await axios.put(`${API_URL}/vehicules/${vehicleId}/status`,
        { statut: newStatus },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data) {
        setVehicles(prevVehicles =>
          prevVehicles.map(v =>
            v.id === vehicleId ? { ...v, statut: newStatus } : v
          )
        );

        setFilteredVehicles(prevVehicles =>
          prevVehicles.map(v =>
            v.id === vehicleId ? { ...v, statut: newStatus } : v
          )
        );

        console.log(`Statut du véhicule ${vehicleId} mis à jour vers ${newStatus}`);
      }
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut:", error);
      alert("Erreur lors de la mise à jour du statut du véhicule");
    }
  };

  const handleBulkStatusUpdate = async (formData) => {
    if (selectedVehicles.length === 0) {
      alert("Veuillez sélectionner au moins un véhicule");
      return;
    }

    try {
      const updatePromises = selectedVehicles.map(vehicleId =>
        axios.put(`${API_URL}/vehicules/${vehicleId}/status`,
          {
            occ_app_3: '', // Nom et prénom
            occ_app_4: '', // Raison sociale
            occ_app_5_2: '', // SIREN
            occ_app_6: '', // Numéro de voie
            occ_app_7: '', // Complément
            occ_app_8: '', // Type de voie
            occ_app_9: '', // Nom de la voie
            occ_app_10: '', // Code postal
            occ_app_11: '', // Commune
            occ_app_13_1: '', // Date de cession - Jour
            occ_app_13_2: '', // Date de cession - Mois
            occ_app_13_3: '', // Date de cession - Année
            occ_app_14_1: '', // Heure de cession
            occ_app_14_2: '', // Minute de cession

            // Champs nouveau propriétaire
            occ_tit_3: '', // Nom et prénom
            occ_tit_4: '', // Nom d'usage
            occ_tit_5_1: '', // Date de naissance - Jour
            occ_tit_5_2: '', // Date de naissance - Mois
            occ_tit_5_3: '', // Date de naissance - Année
            occ_tit_7: '', // Département de naissance
            occ_tit_10: '', // SIRET
            occ_tit_14: '', // Numéro de voie
            occ_tit_15: '', // Extension de voie
            occ_tit_16: '', // Type de voie
            occ_tit_17: '', // Nom de voie
            occ_tit_19: '', // Code postal
            occ_tit_20: '', // Commune
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
              "Content-Type": "application/json",
            },
          }
        )
      );

      await Promise.all(updatePromises);

      setVehicles(prevVehicles =>
        prevVehicles.map(v =>
          selectedVehicles.includes(v.id) ? {
            ...v,
            statut: "Vendu",
            date_vente: formData.date_vente,
            prix_vente: formData.prix_vente,
            mode_paiement: formData.mode_paiement,
            commentaire: formData.commentaire
          } : v
        )
      );

      setFilteredVehicles(prevVehicles =>
        prevVehicles.map(v =>
          selectedVehicles.includes(v.id) ? {
            ...v,
            statut: "Vendu",
            date_vente: formData.date_vente,
            prix_vente: formData.prix_vente,
            mode_paiement: formData.mode_paiement,
            commentaire: formData.commentaire
          } : v
        )
      );

      setSelectedVehicles([]);
      setSelectAll(false);
      setShowVendreEnLotModal(false);
      alert(`${selectedVehicles.length} véhicule(s) mis à jour avec succès`);
    } catch (error) {
      console.error("Erreur lors de la mise à jour des statuts:", error);
      alert("Erreur lors de la mise à jour des statuts des véhicules");
    }
  };

  const handleDeleteVehicle = async (vehicleId) => {
    try {
      if (!window.confirm("Êtes-vous sûr de vouloir supprimer ce véhicule ?")) {
        return;
      }

      const token = localStorage.getItem("token");
      const response = await fetch(`${API_URL}/vehicules/${vehicleId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        setVehicles(vehicules.filter((vehicle) => vehicle.id !== vehicleId));
        setFilteredVehicles(
          filteredVehicles.filter((vehicle) => vehicle.id !== vehicleId)
        );
        alert("Véhicule supprimé avec succès");
      } else {
        throw new Error("Erreur lors de la suppression du véhicule");
      }
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la suppression : " + error.message);
    }
  };

  const fetchUsers = async () => {
    try {
      setIsLoading(true);
      const token = localStorage.getItem("token");

      const usersResponse = await fetch(`${API_URL}/users`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!usersResponse.ok) {
        throw new Error("Erreur lors de la récupération des utilisateurs");
      }

      const usersData = await usersResponse.json();

      const concessionsResponse = await fetch(`${API_URL}/concessions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (concessionsResponse.ok) {
        const concessionsData = await concessionsResponse.json();

        const usersWithConcessions = usersData.map(user => {
          const userConcession = concessionsData.find(c => c.id === parseInt(user.concessions_id));
          return {
            ...user,
            concession: userConcession ? userConcession.nom : "Non assignée"
          };
        });

        setUsers(usersWithConcessions);
        setFilteredUsers(usersWithConcessions);
      } else {
        setUsers(usersData);
        setFilteredUsers(usersData);
      }

      return;
    }

    catch (error) {
      console.error("Erreur:", error);
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const filterUsers = () => {
    return users.filter((user) => {
      const matchSiret =
        !profileFilters.siret ||
        user.siret?.toLowerCase().includes(profileFilters.siret.toLowerCase());
      const matchConcession =
        !profileFilters.concession ||
        user.concession
          ?.toLowerCase()
          .includes(profileFilters.concession.toLowerCase());
      const matchVille =
        !profileFilters.ville ||
        user.ville?.toLowerCase().includes(profileFilters.ville.toLowerCase());
      const matchNom =
        !profileFilters.nom ||
        user.lastName?.toLowerCase().includes(profileFilters.nom.toLowerCase());
      const matchPrenom =
        !profileFilters.prenom ||
        user.firstName
          ?.toLowerCase()
          .includes(profileFilters.prenom.toLowerCase());
      const matchIdentifier =
        !profileFilters.identifier ||
        user.identifier
          ?.toLowerCase()
          .includes(profileFilters.identifier.toLowerCase());

      return (
        matchSiret &&
        matchConcession &&
        matchVille &&
        matchNom &&
        matchPrenom &&
        matchIdentifier
      );
    });
  };

  const handleUpdateUser = async (data, userId) => {
    try {
      try {
        const response = await axios.put(`${API_URL}/users/${userId}`, data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (response.data) {
          fetchUsers();
          alert("Utilisateur mis à jour avec succès");
          setShowEditModal(false);
          return { success: true };
        }
      } catch (error) {
        console.log(
          "Tentative avec URL de production échouée, essai en local..."
        );

        if (error.response?.data) {
          console.error("Erreur validation:", error.response.data);
          return {
            success: false,
            error: error.response.data
          };
        }

        throw error;
      }

    } catch (error) {
      console.error("Erreur:", error);

      if (error.response?.data) {
        return {
          success: false,
          error: error.response.data
        };
      }

      return {
        success: false,
        error: {
          message: error.message || "Erreur lors de la mise à jour de l'utilisateur",
          errorType: "UNKNOWN_ERROR"
        }
      };
    }
  };

  const handleDeleteUser = async (userId) => {
    try {
      if (
        !window.confirm("Êtes-vous sûr de vouloir supprimer cet utilisateur ?")
      ) {
        return;
      }

      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${API_URL}/users/${userId}`, {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          setUsers(users.filter((user) => user.id !== userId));
          setFilteredUsers(filteredUsers.filter((user) => user.id !== userId));
          alert("Utilisateur supprimé avec succès");
          return;
        }
      } catch (error) {
        console.log(
          "Tentative avec URL de production échouée, essai en local..."
        );
      }

      const localResponse = await fetch(`${API_URL}/users/${userId}`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!localResponse.ok) {
        throw new Error("Erreur lors de la suppression");
      }

      setUsers(users.filter((user) => user.id !== userId));
      setFilteredUsers(filteredUsers.filter((user) => user.id !== userId));
      alert("Utilisateur supprimé avec succès");
    } catch (error) {
      console.error("Erreur:", error);
      alert("Erreur lors de la suppression : " + error.message);
    }
  };

  const handleEditClick = (user) => {
    setSelectedUser(user);
    setShowEditModal(true);
  };

  const handleEditSubmit = async (formData) => {
    if (selectedUser) {
      const result = await handleUpdateUser(formData, selectedUser.id);
      if (result && result.success) {
        setShowEditModal(false);
      }
      return result;
    }
    return { success: false, error: { message: "Aucun utilisateur sélectionné" } };
  };

  const handleOpenUserProfile = (user) => {
    setSelectedUser(user);
    setShowUserProfile(true);
  };

  const handleCloseUserProfile = () => {
    setShowUserProfile(false);
  };

  const handleViewVehicle = (vehicleId) => {
    navigate(`/vehicule/${vehicleId}`);
  };

  const handleEditVehicle = (vehicleId) => {
    navigate(`/create-vehicule/${vehicleId}`);
  };

  const getSelectedFolderNames = () => {
    if (selectedVehicles.length === 0) return [];
    return selectedVehicles.map(vehicleId => {
      const vehicle = vehicules.find(v => v.id === vehicleId);
      return vehicle?.numero_dossier || '';
    }).filter(Boolean); // Filtrer les valeurs vides
  };

  return (
    <div className="admin-dashboard-wrapper">
      <Header
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        onMenuToggle={onMenuToggle}
      />
      <PageWrapper isMenuOpen={isMenuOpen}>
        <div className="admin-dashboard-content">
          <div className="tabs">
            <button
              className={`tab-button ${activeTab === "users" ? "active" : ""}`}
              onClick={() => setActiveTab("users")}
            >
              Mes utilisateurs
            </button>
            <button
              className={`tab-button ${activeTab === "vehicules" ? "active" : ""}`}
              onClick={() => setActiveTab("vehicules")}
            >
              Mes véhicules
            </button>
            {/* BOUTON POUR AJOUTER DES DOCS NE PAS SUPPRIMER */}
            {/* <button
              className={`tab-button ${activeTab === "documents" ? "active" : ""}`}
              onClick={() => setActiveTab("documents")}
            >
              <Link to="/document" className="tab-link">
                Ajouter un document
              </Link>
            </button> */}
          </div>

          {isLoading ? (
            <div className="loading">Chargement...</div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : (
            <>
              {activeTab === "users" && (
                <section className="admin-team-section">
                  <div className="admin-section-header">
                    <h2>Mes utilisateurs</h2>
                    <div className="admin-actions-cell">
                      <button
                        className="admin-create-button"
                        onClick={() => setIsCreateGroupFormOpen(true)}
                      >
                        Créer un groupe
                      </button>
                      <button
                        className="admin-create-button"
                        onClick={() => {
                          setSelectedConcession(null);
                          setEditingConcession(false);
                          setIsCreateConcessionFormOpen(true);
                        }}
                      >
                        Créer une concession
                      </button>
                      <button
                        className="admin-create-button"
                        onClick={() => setIsCreateUserFormOpen(true)}
                      >
                        Créer un utilisateur
                      </button>
                    </div>
                  </div>
                  <div className="admin-search-filters">
                    <div className="admin-filters-row">
                      <div className="admin-filter-cell">
                        <label>NOM</label>
                        <input
                          type="text"
                          value={profileFilters.nom}
                          onChange={(e) =>
                            setProfileFilters({
                              ...profileFilters,
                              nom: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="admin-filter-cell">
                        <label>PRENOM</label>
                        <input
                          type="text"
                          value={profileFilters.prenom}
                          onChange={(e) =>
                            setProfileFilters({
                              ...profileFilters,
                              prenom: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="admin-filter-cell">
                        <label>IDENTIFIANT</label>
                        <input
                          type="text"
                          value={profileFilters.identifier}
                          onChange={(e) =>
                            setProfileFilters({
                              ...profileFilters,
                              identifier: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="admin-filters-row">
                      <div className="admin-filter-cell">
                        <label>SIRET</label>
                        <input
                          type="text"
                          name="siret"
                          value={profileFilters.siret}
                          onChange={handleFilterChange}
                          pattern="\d{14}"
                        />
                      </div>
                      <div className="admin-filter-cell">
                        <label>CONCESSION</label>
                        <input
                          type="text"
                          value={profileFilters.concession}
                          onChange={(e) =>
                            setProfileFilters({
                              ...profileFilters,
                              concession: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="admin-filter-cell">
                        <label>VILLE</label>
                        <input
                          type="text"
                          value={profileFilters.ville}
                          onChange={(e) =>
                            setProfileFilters({
                              ...profileFilters,
                              ville: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="admin-filters-row">
                      <div className="admin-filter-cell empty"></div>
                      <div className="admin-filter-cell empty"></div>
                      <div className="admin-filter-cell actions">
                        <button
                          className="admin-reset-button"
                          onClick={() => {
                            setProfileFilters({
                              siret: "",
                              concession: "",
                              ville: "",
                              nom: "",
                              prenom: "",
                              identifier: "",
                            });
                            setFilteredUsers(users);
                          }}
                        >
                          Réinitialiser
                        </button>
                        <button className="admin-search-button">
                          Rechercher
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="admin-table-container">
                    <table className="admin-data-table">
                      <thead>
                        <tr>
                          <th>SIRET</th>
                          <th>CONCESSION</th>
                          <th>VILLE</th>
                          <th>PRENOM</th>
                          <th>NOM</th>
                          <th>STATUT</th>
                          <th>IDENTIFIANT</th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredUsers.map((user) => (
                          <tr key={user.id}>
                            <td>{user.siret}</td>
                            <td>
                              {user.concession ? (
                                <div className="tooltip-container">
                                  <button
                                    className="user-identifier-button"
                                    onClick={() => {
                                      const concessionObj = findConcessionByName(user.concession);
                                      if (concessionObj) {
                                        handleOpenConcessionProfile(concessionObj);
                                      } else {
                                        alert("Détails de la concession non trouvés");
                                      }
                                    }}
                                  >
                                    {user.concession}
                                  </button>
                                  <span className="tooltip-text">Voir fiche concession</span>
                                </div>
                              ) : (
                                "Non assignée"
                              )}
                            </td>
                            <td>{user.ville}</td>
                            <td>{user.firstName}</td>
                            <td>{user.lastName}</td>
                            <td>{user.statut}</td>
                            <td>
                              <div className="tooltip-container">
                                <button
                                  className="user-identifier-button"
                                  onClick={() => handleOpenUserProfile(user)}
                                >
                                  {user.identifier}
                                </button>
                                <span className="tooltip-text">Voir profil utilisateur</span>
                              </div>
                            </td>
                            {user.statut !== "admin" ? (
                              <>
                                <td>
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-edit-button"
                                      onClick={() => handleEditClick(user)}
                                    >
                                      ✏️
                                    </button>
                                    <span className="tooltip-text">Modifier</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-delete-button"
                                      onClick={() => handleDeleteUser(user.id)}
                                    >
                                      ✖️
                                    </button>
                                    <span className="tooltip-text">Supprimer</span>
                                  </div>
                                </td>
                              </>
                            ) : (
                              <>
                                <td></td>
                                <td></td>
                              </>
                            )}

                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </section>
              )}
              {activeTab === "vehicules" && (
                <section className="admin-vehicules-section">
                  <div className="admin-section-header">
                    <h2>Tous les véhicules</h2>
                    <Link to="/create-vehicule">
                      <button className="admin-create-button">
                        Créer un véhicule
                      </button>
                    </Link>
                  </div>
                  <div className="admin-search-filters">
                    <div className="admin-filters-row">
                      <div className="admin-filter-cell">
                        <label>Statut</label>
                        <select
                          name="statut"
                          value={vehicleFilters.statut}
                          onChange={handleVehicleFilterChange}
                        >
                          <option value="">Tous</option>
                          <option value="Commande">Commande</option>
                          <option value="Stock">Stock</option>
                          <option value="Vendu">Vendu</option>
                          <option value="Demo">Démo</option>
                        </select>
                      </div>
                      <div className="admin-filter-cell">
                        <label>N° de châssis</label>
                        <input
                          type="text"
                          value={vehicleFilters.numero_chassis}
                          onChange={(e) =>
                            setVehicleFilters({
                              ...vehicleFilters,
                              numero_chassis: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="admin-filter-cell">
                        <label>N° de dossier</label>
                        <input
                          type="text"
                          value={vehicleFilters.numero_dossier}
                          onChange={(e) =>
                            setVehicleFilters({
                              ...vehicleFilters,
                              numero_dossier: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>

                    <div className="admin-filters-row">
                      <div className="admin-filter-cell">
                        <label>Vendeur</label>
                        <input
                          type="text"
                          value={vehicleFilters.vendeur}
                          onChange={(e) =>
                            setVehicleFilters({
                              ...vehicleFilters,
                              vendeur: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="admin-filter-cell">
                        <label>Nom du client</label>
                        <input
                          type="text"
                          value={vehicleFilters.nom_client}
                          onChange={(e) =>
                            setVehicleFilters({
                              ...vehicleFilters,
                              nom_client: e.target.value,
                            })
                          }
                        />
                      </div>
                      <div className="admin-filter-cell actions">
                        <button
                          className="admin-reset-button"
                          onClick={() => {
                            setVehicleFilters({
                              statut: "",
                              numero_dossier: "",
                              numero_chassis: "",
                              vendeur: "",
                              nom_client: "",
                            });
                            setFilteredVehicles(vehicules);
                          }}
                        >
                          Réinitialiser
                        </button>
                        <button
                          className="admin-search-button"
                          onClick={() => setFilteredVehicles(filterVehicles())}
                        >
                          Rechercher
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="admin-table-container">
                    <table className="admin-data-table">
                      <thead>
                        <tr>
                          <th>STATUT</th>
                          <th>NUMÉRO DE DOSSIER</th>
                          <th>NUMÉRO DE CHASSIS</th>
                          <th>NOM DU CLIENT</th>
                          <th>NOM DU VENDEUR</th>
                          <th></th>
                          <th></th>
                          <th>
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onChange={handleSelectAll}
                              className="admin-checkbox"
                            />
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(filteredVehicles) && filteredVehicles.length > 0 ? (
                          filteredVehicles.map((vehicle) => (
                            vehicle ? (
                              <tr key={vehicle.id}>
                                <td>
                                  <select
                                    value={vehicle.statut || ""}
                                    onChange={(e) => handleUpdateVehicleStatus(vehicle.id, e.target.value)}
                                    className="status-select"
                                    style={{ width: "fit-content" }}
                                  >
                                    <option value="Commande">Commande</option>
                                    <option value="Stock">Stock</option>
                                    <option value="Vendu">Vendu</option>
                                    <option value="Demo">Démo</option>
                                  </select>
                                </td>
                                <td>{vehicle.numero_dossier || "N/A"}</td>
                                <td>{vehicle.veh_6 || "N/A"}</td>
                                <td>{`${vehicle.occ_tit_3 || ""} ${vehicle.tit_3 || ""}`.trim() || "N/A"}</td>
                                <td>{vehicle.vendeur_nom || "N/A"}</td>
                                <td className="admin-actions-cell">
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-view-button"
                                      onClick={() => handleViewVehicle(vehicle.id)}
                                      style={{ background: 'none', border: 'none', padding: '5px', cursor: 'pointer' }}
                                    >
                                      👁️
                                    </button>
                                    <span className="tooltip-text">Voir</span>
                                  </div>
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-edit-button"
                                      onClick={() => handleEditVehicle(vehicle.id)}
                                    >
                                      ✏️
                                    </button>
                                    <span className="tooltip-text">Modifier</span>
                                  </div>
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-download-button"
                                      onClick={() => handleOpenDocumentModal(vehicle.id)}
                                    >
                                      📥
                                    </button>
                                    <span className="tooltip-text">Télécharger</span>
                                  </div>
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-duplicate-button"
                                      onClick={() => handleDuplicateVehicle(vehicle.id)}
                                    >
                                      📋
                                    </button>
                                    <span className="tooltip-text">Dupliquer</span>
                                  </div>
                                  <div className="tooltip-container">
                                    <button
                                      className="admin-delete-button"
                                      onClick={() => handleDeleteVehicle(vehicle.id)}
                                    >
                                      ✖️
                                    </button>
                                    <span className="tooltip-text">Supprimer</span>
                                  </div>
                                </td>
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={selectedVehicles.includes(vehicle.id)}
                                    onChange={() => handleSelectVehicle(vehicle.id)}
                                    className="admin-checkbox"
                                  />
                                </td>
                              </tr>
                            ) : null
                          ))
                        ) : (
                          <tr>
                            <td colSpan="8" className="no-data-message">
                              Aucun véhicule trouvé
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="admin-sell-button-container">
                    <button
                      className="admin-sell-button"
                      onClick={() => setShowVendreEnLotModal(true)}
                    >
                      Vendre en lot
                    </button>
                  </div>
                </section>
              )}
            </>
          )}
        </div>
      </PageWrapper>
      <Footer />
      {(isCreateUserFormOpen) && (
        <CreateUserAdminForm
          user={selectedUser}
          onClose={() => {
            setIsCreateUserFormOpen(false);
            setSelectedUser(null);
            fetchUsers();
          }}
        />
      )}
      {isCreateConcessionFormOpen && (
        <CreateConcessionForm
          concession={editingConcession ? selectedConcession : null}
          onClose={() => {
            setIsCreateConcessionFormOpen(false);
            setEditingConcession(false);
            setSelectedConcession(null);
            fetchConcessions();
            fetchUsers();
          }}
        />
      )}
      {isCreateGroupFormOpen && (
        <CreateGroupForm
          onClose={() => {
            setIsCreateGroupFormOpen(false);
          }}
        />
      )}
      <EditUserModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        onSubmit={handleEditSubmit}
        user={selectedUser}
      />
      <DocumentModal
        show={isDocumentModalOpen}
        onHide={() => setIsDocumentModalOpen(false)}
        vehiculeId={selectedVehicleId}
      />
      {showUserProfile && selectedUser && (
        <UserProfileModal
          show={showUserProfile}
          onHide={handleCloseUserProfile}
          user={selectedUser}
          onEdit={handleEditClick}
        />
      )}
      {showConcessionProfile && selectedConcession && (
        <ConcessionProfileModal
          show={showConcessionProfile}
          onHide={handleCloseConcessionProfile}
          concession={selectedConcession}
          onEdit={handleEditConcession}
        />
      )}
      <VendreEnLot
        show={showVendreEnLotModal}
        onHide={() => setShowVendreEnLotModal(false)}
        selectedVehicles={selectedVehicles}
        onSuccess={() => {
          setSelectedVehicles([]);
          setSelectAll(false);
          fetchVehicles();
        }}
        selectedVehiclesCount={selectedVehicles.length}
        numero_dossier={getSelectedFolderNames()}
        onSubmit={handleBulkStatusUpdate}
      />
    </div>
  );
};

AdminDashboard.propTypes = {
  menuState: PropTypes.shape({
    isMenuOpen: PropTypes.bool,
    setIsMenuOpen: PropTypes.func,
    onMenuToggle: PropTypes.func,
  }),
};

export default AdminDashboard;
